"use client";

import { Typography } from "@/components/ui/typography";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { AlertCircleIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { cn } from "@/lib/utils";
import * as PopoverPrimitive from "@radix-ui/react-popover";

interface InfoTooltipProps {
  content: string;
  className?: string;
  iconClassName?: string;
}

const overlayClassName =
  "bg-black text-white border-none max-w-[240px] md:max-w-[320px]";
const arrowClassName =
  "bg-black fill-black z-50 size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-[2px]";

export function InfoTooltip({
  content,
  className = "",
  iconClassName = "size-[18px] text-black-300",
}: InfoTooltipProps) {
  const isHoverDevice = useMediaQuery("(hover: hover) and (pointer: fine)");

  const icon = (
    <HugeiconsIcon
      icon={AlertCircleIcon}
      className={cn(
        isHoverDevice ? "cursor-help" : "cursor-pointer",
        iconClassName,
      )}
    />
  );

  const body = (
    <Typography variant="captionRegular" color="white">
      {content}
    </Typography>
  );

  if (!isHoverDevice) {
    return (
      <Popover>
        <PopoverTrigger
          className={cn("inline-flex items-center", className)}
          aria-label="اطلاعات بیشتر"
        >
          {icon}
        </PopoverTrigger>
        <PopoverContent
          side="top"
          align="center"
          sideOffset={8}
          avoidCollisions
          className={cn(overlayClassName, "w-fit px-3 py-1.5 shadow-none")}
        >
          {body}
          <PopoverPrimitive.Arrow className={arrowClassName} />
        </PopoverContent>
      </Popover>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild className={className}>
          {icon}
        </TooltipTrigger>
        <TooltipContent className={overlayClassName}>{body}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
